export const CORN_DENSITY_LIMITS_CONFIG = { min: 30000, max: 120000, step: 500 };

export const getCornPlantingDensity = (harvestDensity, planterEfficiency, seedsPerBag) => {
    if (!harvestDensity || !planterEfficiency) return {};
    const density = (harvestDensity / planterEfficiency) * 100;
    const bagsPerHectare = seedsPerBag ? density / seedsPerBag : undefined;
    return { planterEfficiency, density, bagsPerHectare };
};
